import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'

export const Route = createFileRoute(
  '/libra-dashboard/$orgID/$dashboardConfigId'
)({
  component: RouteComponent,
  staticData: {
    title: 'Libra Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  return <LibraDashboardPage />
}
